if(!customElements.get('util-tabs')) {
  class UtilTabs extends HTMLElement { 
    constructor() {
      super();

        var tabItem = this;
        var tablist = tabItem.querySelector('[role="tablist"]')
        var tabs;
        var panels;
        var associatedElements;
        var delay = determineDelay();
    
        generateArrays();

        function getPanelContentEl(panel) {
          if (!panel) return null;
          var content = panel.querySelector('[data-tab-panel-content]') || panel.querySelector('.scrollable');
          if (content && !content.id) {
            content.id = panel.id + '-content';
            content.setAttribute('data-tab-panel-content', '');
          }
          return content;
        }

        function panelHasInteractiveContent(panel) {
          return !!(panel && panel.querySelector('[data-tab-panel-content] a, [data-tab-panel-content] button, [data-tab-panel-content] input, [data-tab-panel-content] select, [data-tab-panel-content] textarea, .scrollable a, .scrollable button'));
        }

        function getAssociatedButtons(tab) {
          var associatedId = tab.getAttribute('aria-controls') + '-associated';
          var associated = document.getElementById(associatedId);
          if (!associated || associated.hasAttribute('hidden')) return [];
          return Array.prototype.slice.call(associated.querySelectorAll('.container-ingredient'));
        }

        function findTabIndexForButton(btn) {
          for (var i = 0; i < tabs.length; i++) {
            var associated = document.getElementById(tabs[i].getAttribute('aria-controls') + '-associated');
            if (associated && associated.contains(btn)) return i;
          }
          return -1;
        }

        function setupInterleaveTabNavigation() {
          if (!tabItem.hasAttribute('data-tab-interleave-ingredients') || tabItem.interleaveNavigationBound) return;
          tabItem.interleaveNavigationBound = true;

          for (var i = 0; i < tabs.length; i++) {
            (function(tab, index) {
              tab.addEventListener('keydown', function(e) {
                if (e.key !== 'Tab') return;
                var cards = getAssociatedButtons(tab);

                if (!e.shiftKey && document.activeElement === tab && cards.length) {
                  e.preventDefault();
                  cards[0].focus();
                  return;
                }

                if (e.shiftKey && document.activeElement === tab && index > 0) {
                  var prevCards = getAssociatedButtons(tabs[index - 1]);
                  if (prevCards.length) {
                    e.preventDefault();
                    prevCards[prevCards.length - 1].focus();
                  }
                }
              });
            })(tabs[i], i);
          }

          tabItem.querySelectorAll('.container-ingredient').forEach(function(btn) {
            btn.addEventListener('keydown', function(e) {
              if (e.key !== 'Tab') return;
              var tabIndex = findTabIndexForButton(btn);
              if (tabIndex < 0) return;
              var cards = getAssociatedButtons(tabs[tabIndex]);
              var cardIndex = cards.indexOf(btn);
              if (cardIndex < 0) return;

              if (!e.shiftKey && cardIndex === cards.length - 1) {
                if (tabIndex < tabs.length - 1) {
                  e.preventDefault();
                  tabs[tabIndex + 1].focus();
                }
                return;
              }

              if (e.shiftKey && cardIndex === 0) {
                e.preventDefault();
                tabs[tabIndex].focus();
              }
            });
          });
        }

        function updateTabAccessibility() {
          var useInterleave = tabItem.hasAttribute('data-tab-interleave-ingredients');

          for (var t = 0; t < tabs.length; t++) {
            var tab = tabs[t];
            var controls = tab.getAttribute('aria-controls');
            var panel = controls ? document.getElementById(controls) : null;
            var contentEl = getPanelContentEl(panel);

            tab.setAttribute('tabindex', '0');

            if (panel) {
              panel.setAttribute('tabindex', '-1');
            }

            if (contentEl && !panelHasInteractiveContent(panel)) {
              contentEl.setAttribute('aria-hidden', 'true');
              tab.setAttribute('aria-describedby', contentEl.id);
            } else if (contentEl) {
              contentEl.removeAttribute('aria-hidden');
              tab.removeAttribute('aria-describedby');
            } else {
              tab.removeAttribute('aria-describedby');
            }
          }

          if (useInterleave) {
            for (var i = 0; i < tabs.length; i++) {
              var associatedId = tabs[i].getAttribute('aria-controls') + '-associated';
              var associated = document.getElementById(associatedId);
              if (!associated) continue;
              var hidden = associated.hasAttribute('hidden');
              associated.querySelectorAll('.container-ingredient').forEach(function(btn) {
                btn.tabIndex = hidden ? -1 : 0;
              });
            }
          } else {
            tabItem.querySelectorAll('.container-ingredient').forEach(function(btn) {
              btn.removeAttribute('tabindex');
            });
          }
        }
    
        function generateArrays () {
          tabs = tabItem.querySelectorAll('[role="tab"]');
          panels = tabItem.querySelectorAll('[role="tabpanel"]');
          associatedElements = tabItem.querySelectorAll('.associate');
        };
    
        // For easy reference
        var keys = {
          end: 35,
          home: 36,
          left: 37,
          up: 38,
          right: 39,
          down: 40
          //,delete: 46
        };
    
        // Add or substract depending on key pressed
        var direction = {
          37: -1,
          38: -1,
          39: 1,
          40: 1
        };
    
        // Bind listeners
        for (var i = 0; i < tabs.length; ++i) {
          addListeners(i);
        };
    
        function addListeners (index) {
          tabs[index].addEventListener('click', clickEventListener);
          tabs[index].addEventListener('keydown', keydownEventListener);
          tabs[index].addEventListener('keyup', keyupEventListener);
          tabs[index].addEventListener('focus', function(event) {
            activateTab(event.currentTarget, false);
          });
    
          // Build an array with all tabs (<button>s) in it
          tabs[index].index = index;
        };
    
        // When a tab is clicked, activateTab is fired to activate it
        function clickEventListener (event) {
          var tab = event.target;
          activateTab(tab, false);
        };
    
        // Handle keydown on tabs
        function keydownEventListener (event) {
          var key = event.keyCode;
    
          switch (key) {
            case keys.end:
              event.preventDefault();
              // Activate last tab
              activateTab(tabs[tabs.length - 1]);
              break;
            case keys.home:
              event.preventDefault();
              // Activate first tab
              activateTab(tabs[0]);
              break;
    
            // Up and down are in keydown
            // because we need to prevent page scroll >:)
            case keys.up:
            case keys.down:
              determineOrientation(event);
              break;
          };
        };
    
        // Handle keyup on tabs
        function keyupEventListener (event) {
          var key = event.keyCode;
    
          switch (key) {
            case keys.left:
            case keys.right:
              determineOrientation(event);
              break;
            case keys.delete:
              determineDeletable(event);
              break;
          };
        };
    
        // When a tablistâ€™s aria-orientation is set to vertical,
        // only up and down arrow should function.
        // In all other cases only left and right arrow function.
        function determineOrientation (event) {
          var key = event.keyCode;
          var vertical = tablist.getAttribute('aria-orientation') == 'vertical';
          var proceed = false;
    
          if (vertical) {
            if (key === keys.up || key === keys.down) {
              event.preventDefault();
              proceed = true;
            };
          }
          else {
            if (key === keys.left || key === keys.right) {
              proceed = true;
            };
          };
    
          if (proceed) {
            switchTabOnArrowPress(event);
          };
        };
    
        // Either focus the next, previous, first, or last tab
        // depening on key pressed
        function switchTabOnArrowPress (event) {
          var pressed = event.keyCode;
    
          for (var x = 0; x < tabs.length; x++) {
            tabs[x].addEventListener('focus', focusEventHandler);
          };
    
          if (direction[pressed]) {
            var target = event.target;
            if (target.index !== undefined) {
              if (tabs[target.index + direction[pressed]]) {
                tabs[target.index + direction[pressed]].focus();
              }
              else if (pressed === keys.left || pressed === keys.up) {
                focusLastTab();
              }
              else if (pressed === keys.right || pressed == keys.down) {
                focusFirstTab();
              };
            };
          };
        };
    
        // Activates any given tab panel
        function activateTab (tab, setFocus) {
          setFocus = setFocus==undefined ? true : setFocus;
          // Deactivate all other tabs
          deactivateTabs();
    
          // Set the tab as selected
          tab.setAttribute('aria-selected', 'true');
    
          // Get the value of aria-controls (which is an ID)
          var controls = tab.getAttribute('aria-controls');
    
          // Remove hidden attribute from tab panel to make it visible
          document.getElementById(controls).removeAttribute('hidden');

          // Remove hidden attribute from associated element
          var associated = document.getElementById(controls + "-associated");
          if(associated)
            associated.removeAttribute('hidden');
    
          // Set focus when required
          if (setFocus) {
            tab.focus();
          };

          updateTabAccessibility();
        };
    
        // Deactivate all tabs and tab panels
        function deactivateTabs () {
          for (var t = 0; t < tabs.length; t++) {
            tabs[t].setAttribute('aria-selected', 'false');
            tabs[t].removeEventListener('focus', focusEventHandler);
          };
    
          for (var p = 0; p < panels.length; p++) {
            panels[p].setAttribute('hidden', 'hidden');
          };

          for (var q = 0; q < associatedElements.length; q++) {
            associatedElements[q].setAttribute('hidden', 'hidden');
          };
        };
    
        // Make a guess
        function focusFirstTab () {
          tabs[0].focus();
        };
    
        // Make a guess
        function focusLastTab () {
          tabs[tabs.length - 1].focus();
        };
    
        // Detect if a tab is deletable
        function determineDeletable (event) {
          target = event.target;
    
          if (target.getAttribute('data-deletable') !== null) {
            // Delete target tab
            deleteTab(event, target);
    
            // Update arrays related to tabs widget
            generateArrays();
    
            // Activate the closest tab to the one that was just deleted
            if (target.index - 1 < 0) {
              activateTab(tabs[0]);
            }
            else {
              activateTab(tabs[target.index - 1]);
            };
          };
        };
    
        // Deletes a tab and its panel
        function deleteTab (event) {
          var target = event.target;
          var panel = document.getElementById(target.getAttribute('aria-controls'));
    
          target.parentElement.removeChild(target);
          panel.parentElement.removeChild(panel);
        };
    
        // Determine whether there should be a delay
        // when user navigates with the arrow keys
        function determineDelay () {
          var hasDelay = tablist.hasAttribute('data-delay');
          var delay = 0;
    
          if (hasDelay) {
            var delayValue = tablist.getAttribute('data-delay');
            if (delayValue) {
              delay = delayValue;
            }
            else {
              // If no value is specified, default to 300ms
              delay = 300;
            };
          };
    
          return delay;
        };
    
        //
        function focusEventHandler (event) {
          var target = event.target;
    
          setTimeout(checkTabFocus, delay, target);
        };
    
        // Only activate tab on focus if it still has focus after the delay
        function checkTabFocus (target) {
          var focused = document.activeElement;
    
          if (target === focused) {
            activateTab(target, false);
          };
        };

        updateTabAccessibility();
        setupInterleaveTabNavigation();

    }

  };
  

  customElements.define('util-tabs', UtilTabs);
}



